<template>
  <div class="mil_tab">
    <div class="mil_level">
      <h3>What course level will you be enrolling in?</h3>
      <br>
      <input type="radio" id="milgradyes" v-bind:value="true" v-model="isGrad">
      <label for="milgradyes">Graduate</label>
      <br>
      <input type="radio" id="milgradno" v-bind:value="false" v-model="isGrad">
      <label for="milgradno">Undergraduate</label>
      <br>
    </div>
    <div class="milActiveDuty">
      <h3>Are you an active duty or National Guard service member?</h3>
      <br>
      <input type="radio" id="milyes" v-bind:value="true" v-model="isActiveDutyMil">
      <label for="milyes">Yes</label>
      <br>
      <input type="radio" id="milno" v-bind:value="false" v-model="isActiveDutyMil">
      <label for="milno">No</label>
      <br>
    </div>
    <div class="milVeteran" v-show="isGrad && isGrad !== null">
      <h3>Are you a veteran or veteran's spouse?</h3>
      <br>
      <input type="radio" id="milvetyes" v-bind:value="true" v-model="isMilVeteran">
      <label for="milvetyes">Yes</label>
      <br>
      <input type="radio" id="milvetsno" v-bind:value="false" v-model="isMilVeteran">
      <label for="milvetsno">No</label>
      <br>
    </div>
    <div class="milFamily" v-show="!isGrad && isGrad !== null">
      <h3>Are you a family member of a service member?</h3>
      <br>
      <input type="radio" id="famyes" v-bind:value="true" v-model="isMilFamily">
      <label for="famyes">Yes</label>
      <br>
      <input type="radio" id="famno" v-bind:value="false" v-model="isMilFamily">
      <label for="famno">No</label>
      <br>
    </div>


    <div class="milhours">
      <h3>How many credit hours?</h3>
      <br>
      <select v-model="milHours">
        <option disabled value="">Please select estimated credit hours</option>
        <option>1</option>
        <option>2</option>
        <option>3</option>
        <option>4</option>
        <option>5</option>
        <option>6</option>
        <option>7</option>
        <option>8</option>
        <option>9</option>
        <option>10</option>
        <option>11</option>
        <option>12</option>
        <option>13</option>
        <option>14</option>
        <option>15</option>
      </select>
      <br>
    </div>
    <div class="mil_calc">
      <div class="mil_calc_button_div">
        <button class="mil_calc_button" @click="calculateMilTuition">Calculate Tuition</button>
      </div>
      <div class="mil_tuition_amt" v-show="showMilTuition">
        <div class="mil_calc_tuition_num">${{calculatedMilTuition}}</div>: per semester
        <div class="clearfix"></div>
        <button class="reset_button" @click="resetCalc" v-show="showMilTuition">Reset</button>
      </div>

    </div>


  </div>
</template>

<script>

export default {
  name: "Military",
  data(){
    return{
      isGrad:null,
      isActiveDutyMil:false,
      isMilVeteran:false,
      isMilFamily:false,
      milHours:0,
      calculatedMilTuition:0,
      showMilTuition:false,
      miltuition:[]
    }
  },mounted() {
    this.getMilTuition()
  }, methods:{
    getMilTuition() {

      this.miltuition = [{
        "stutype": "Active Duty or National Guard",
        "level": "Grad",
        "fulltime": 0,
        "perhour": 250,
        "genfees": 42,
        "notes": ["4"]
      },
        {
          "stutype": "Veteran or Spouse",
          "level": "Grad",
          "fulltime": 0,
          "perhour": 380,
          "genfees": 42,
          "notes": ["4"]
        },{
          "stutype": "Military Family",
          "level": "Undergrad",
          "fulltime": 4350,
          "perhour": 362,
          "genfees": 500,
          "notes": ["1", "3"]
        },
        {
          "stutype": "Active Duty or National Guard",
          "level": "Undergrad",
          "fulltime": 0,
          "perhour": 250,
          "genfees": 42,
          "notes": ["1", "3"]
        }];

    },calculateMilTuition(){
      let mil_per_hour = 0
      let mil_fee  = 0
      let level = ''
      let stutype = ''

      if (this.isGrad){
        level = 'Grad'
        if(this.isActiveDutyMil){
          stutype = 'Active Duty or National Guard'
        } else if (this.isMilVeteran){
          stutype = 'Veteran or Spouse'
        } else {
          alert('Please use Graduate tab to calculate tuition')
          return;
        }
      }  else {
        level = 'Undergrad'
        if(this.isActiveDutyMil){
          stutype = 'Active Duty or National Guard'
        } else if (this.isMilFamily){
          stutype = 'Military Family'
        } else {
          alert('Please use Undergrad tab to calculate tuition')
          return;
        }
      }

      mil_per_hour = this.miltuition.find(function (record){
        return record.stutype === stutype && record.level === level
      }).perhour
      mil_fee = this.miltuition.find(function (record){
        return record.stutype === stutype && record.level === level
      }).genfees

      mil_per_hour*=parseInt(this.milHours)
      mil_fee*=parseInt(this.milHours)

      if (!this.isGrad && this.isMilFamily && (parseInt(this.milHours) >= 12)){
        mil_fee = 500
        mil_per_hour = this.miltuition.find(function (record){
          return record.stutype === stutype && record.level === level
        }).fulltime
      }

      if ((55 * parseInt(this.milHours) >= 500)){
        mil_fee = 500
      } else {
        mil_fee = 55 * parseInt(this.milHours)
      }

      this.calculatedMilTuition = mil_per_hour + mil_fee
      this.showMilTuition = true
    }, resetCalc(){
      console.log('Calculation reset')
      this.showMilTuition = false
      this.isGrad = null
      this.isActiveDutyMil = false
      this.isMilFamily = false
      this.isMilVeteran = false
      this.milHours = 0
    }
  }
}
</script>

<style scoped>
.mil_tab{
  text-align: left;
}

.mil_level, .milActiveDuty, .milVeteran, .milFamily, .milhours{
  width: auto;
  border-style: solid;
  padding-left: 10px;
  border-bottom: solid;
  border-bottom-color: lightgray;
  border-right: none;
  border-left: none;
  border-top: none;
  padding-bottom: 10px;
  margin-bottom: 5px;
}
.mil_calc{
  text-align: right;
  overflow: auto;
  padding-top: 10px;
  padding-bottom: 10px;
}

.mil_calc_button{
  float:left;
  margin-left: 20px;
  display: block;
  background-color: #004976;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  font-size: 16px;
  cursor: pointer;
}

.mil_tuition_amt{
  float: right;
  padding-right: 20px;
  display: inline-block;

}

.mil_calc_tuition_num{
  float: left;
  font-family: "Droid Serif";
  font-weight: bold;
  font-size: xx-large;
}

.reset_button{
  float: right;
  text-align: center;
  text-decoration: none;
  font-size: 12px;
  cursor: pointer;
  background-color: #004976;
  color: white;
  margin-right: 20px;
  margin-top: 20px;
}


</style>